import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import PageTitle from '../../components/pageTitle';
import { getProjectsByStatus } from '../../mockData';
import { getLanguageFontWithFallback } from '../../utils/fontUtils';
import './index.css';
import './index.tablet.css';
import './index.mobile.css';

function Project() {
  const navigate = useNavigate();
  const { t, i18n } = useTranslation();
  // const [selectedFilter, setSelectedFilter] = useState('all');
  const [selectedFilter] = useState('all');

  
  // 获取当前语言
  const currentLang = i18n.language || 'zh';
  
  // 从 mockData 获取项目数据，按开始日期倒序（最新在最前）
  const projectsData = getProjectsByStatus(selectedFilter)
    .slice()
    .sort((a, b) => new Date(b.startDate) - new Date(a.startDate));
  
  // 处理项目卡片点击
  const handleProjectClick = (projectId) => {
    navigate(`/projects/${projectId}`);
  };

  // const filters = [
  //   { key: 'all', label: t('projects.filter.all') },
  //   { key: 'completed', label: t('projects.filter.completed') },
  //   { key: 'in-progress', label: t('projects.filter.inProgress') },
  //   // { key: 'pending', label: t('projects.filter.pending') } // 暂时隐藏
  // ];

  // 云朵背景图路径
  const cloudBgUrl = `${process.env.PUBLIC_URL}/image/云朵背景.jpg`;

  return (
    <div className="project-container">
      <div 
        className="project-cloud-bg"
        style={{
          backgroundImage: `url(${cloudBgUrl})`
        }}
      />
      <div className="project-section-container">
        <PageTitle marginBottom="48px">
          <span style={{ fontFamily: getLanguageFontWithFallback(currentLang) }}>{t('projects.title')}</span>
        </PageTitle>
        
        {/* <div className="project-filters">
          {filters.map((filter) => (
            <button
              key={filter.key}
              className={`project-filter-button ${selectedFilter === filter.key ? 'active' : ''}`}
              onClick={() => setSelectedFilter(filter.key)}
              disabled={filter.key !== 'all'}
            >
              {filter.label}
            </button>
          ))}
        </div> */}

        <div className="project-grid">
          {projectsData.map((project) => (
            <div 
              key={project.id} 
              className="project-card"
              onClick={() => handleProjectClick(project.id)}
              style={{ cursor: 'pointer' }}
            >
              <div className="project-card-image-wrapper">
                <img 
                  src={project.image} 
                  alt={project.title[currentLang]}
                  className="project-card-image"
                />
                <div className={`project-status-badge ${project.status === 'completed' ? 'completed' : project.status === 'in-progress' ? 'in-progress' : 'pending'}`}>
                  {project.status === 'completed' ? t('projects.status.completed') : project.status === 'in-progress' ? t('projects.status.inProgress') : t('projects.status.pending')}
                </div>
              </div>
              <div className="project-card-content">
                <h3 className="project-card-title">{project.title[currentLang]}</h3>
                <div className="project-card-meta">
                  {/* <Tag variant={project.categoryVariant}>
                    {project.category[currentLang]}
                  </Tag> */}
                  <div className="project-card-info">
                    {/* <span className="project-card-number">
                      {t('projects.projectNumber')} {project.projectNumber}
                    </span> */}
                    <span className="project-card-date">
                      <span className="project-card-date-label">{t('projects.startDate')}</span>
                      <span className="project-card-date-value">{project.startDate}</span>
                    </span>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}

export default Project;
